import React from 'react';

export default function ComponentDelete() {
  return (
    <div style={{ textAlign: 'center' }}>
      <p>Está ação não poderá mais ser desfeita pelo sistema.</p>
    </div>
  );
}
